<template>
  <div class="ui stackable grid container">
    <SettingsMenu />

    <div class="eight wide column">
      <div class="ui segment">
        <h2 class="ui dividing header">Licenças</h2>

        <!-- <Notification
          :message="notification.message"
          :type="notification.type"
          v-if="notification.message"
        />-->

        <!-- <form class="ui form" @submit.prevent="updateProfile"> -->
        <!-- <div class="field">
            <label>Email Usuario 1</label>
            <input type="text" name="name" />
          </div> 
        </form>-->
        <div v-for="licence in licences" v-bind:key="licence.id">
          Usuario {{licence.id}}
          <text-field label="Nome" type="text" v-model="email"></text-field>
          <text-field label="Email" type="text" v-model="email"></text-field>
          <text-field label="Telefone" type="text" v-model="email"></text-field>
        </div>
        <!-- <button type="button" v-on:click="addFormElement()">Add Form Element</button> -->
        <button class="ui button primary">Atualizar Licenças</button>
      </div>
    </div>
  </div>
</template>


<script>
import TextField from "@/components/TextField";
// import Notification from "@/components/Notification";
import SettingsMenu from "@/components/Settings/SettingsMenu";

// const axios = require("axios").default; //this js should be the only one with direct axios import
//
export default {
  name: "ProfileSettings",
  components: {
    // Notification,
    TextField,
    SettingsMenu
  },
  data() {
    return {
      licences: [],
      count: 0,
      email: ""
    };
    // name: "",
    // username: "",
    // email: "",
    // bio: "",
    // location: "",
    // websiteUrl: "",
    // notification: {
    //   message: "",
    //   type: ""
    // }
  },
  beforeRouteEnter(to, from, next) {
    const token = "temp"; //localStorage.getItem("tweetr-token");
    return token ? next() : next("/login");
  },
  created() {
    // this.fetchAuthenticatedUser();
  },
  mounted() {
    this.addFormElement();
    this.addFormElement();
  },
  methods: {
    addFormElement: function() {
      this.licences.push({
        type: "text",
        id: ++this.count
      });
    },
    // fetchAuthenticatedUser() {
    //   //   const token = localStorage.getItem("tweetr-token");
    //   //   axios
    //   //     .get("account/me", {
    //   //       headers: {
    //   //         Authorization: `Bearer ${token}`
    //   //       }
    //   //     })
    //   //     .then(response => {
    //   //       this.name = response.data.data.name;
    //   //       this.username = response.data.data.username;
    //   //       this.email = response.data.data.email;
    //   //       this.location = response.data.data.location;
    //   //       this.bio = response.data.data.bio;
    //   //       this.websiteUrl = response.data.data.website_url;
    //   //     });
    // },
    updateProfile() {
      //   const token = "temp"; //localStorage.getItem("tweetr-token");
      //   axios
      //     .put(
      //       "/account/update_profile",
      //       {
      //         name: this.name,
      //         username: this.username,
      //         email: this.email,
      //         location: this.location,
      //         bio: this.bio,
      //         website_url: this.websiteUrl
      //       },
      //       {
      //         headers: {
      //           Authorization: `Bearer ${token}`
      //         }
      //       }
      //     )
      //     .then(response => {
      //       // display success notification
      //       this.notification = Object.assign({}, this.notification, {
      //         message: response.data.message,
      //         type: "success"
      //       });
      //     });
    }
  }
};
</script>